import { PlatformModulesEnum, PLATFORM_MODULES_PERMISSIONS } from '@thinknet-gmbh/platform-common';

export const YUU_HR_PERMISSIONS = Object.values(
  PLATFORM_MODULES_PERMISSIONS[PlatformModulesEnum.YUU_HR_MODULE]
);

export const DEFAULT_PERMISSION_DOC = {
  name: '',
  isConfirmed: false,
  permissions: [],
};
